import React, { useMemo } from 'react';
import { OptionKey, SelectDropdown } from '@common-fe/common-fe';

import { ALL_OPTION_KEY } from '@/common/constants';
import { useSelectAllHandler } from '@/modules/core';
import { CLAIM_STATUSES_OPTIONS } from '@/modules/Reports/report.types';

interface Props {
  testId?: string;
  value: OptionKey[];
  disabled?: boolean;
  onChangeValue: (value: OptionKey[]) => void;
}
const ClaimStatusSelector: React.FC<Props> = ({
  testId = 'claim_status_selector',
  disabled,
  value,
  onChangeValue,
}) => {
  const currentValue = useMemo(() => {
    if (!value.length && !disabled) {
      return [ALL_OPTION_KEY];
    }
    return value;
  }, [disabled, value]);

  const handleChangeValue = useSelectAllHandler(value, onChangeValue);

  return (
    <SelectDropdown
      ellipsisMode
      testId={testId}
      disabled={disabled}
      activeTitle
      options={CLAIM_STATUSES_OPTIONS}
      values={currentValue}
      onChangeValues={handleChangeValue}
      prefix="Claim status"
      id="claim_status_selector"
      name="claim_status_selector"
      allMode
    />
  );
};

export default ClaimStatusSelector;
